import { Button, DropdownFooterProps, NavListSeparator } from '@billy/design-system'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useOpenConnectBankModal } from '@features/bankAccounts/hooks/useOpenConnectBankModal'

import { useSegment } from '../../../../../../hooks'
import { UiSource } from '../../../../enums'
import * as Styled from './styles'

export const BankReconciliationAccountSelectAddAccount = ({ onFooterItemClick }: DropdownFooterProps): ReactElement => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const openConnectBankModal = useOpenConnectBankModal()

  const handleAddNewConnectedBankAccountClick = () => {
    track('XXX - Reconciliation Add Account Initiated (Client)')
    onFooterItemClick?.()
    openConnectBankModal(UiSource.OldReconAddAccountDropdown)
  }

  return (
    <Styled.BankReconciliationAccountSelectAddAccountWrapper onClick={handleAddNewConnectedBankAccountClick}>
      <NavListSeparator />
      <Button icon="circlePlus" variant="text" size="lg" fullWidth>
        {t('bank_integration.add_account')}
      </Button>
    </Styled.BankReconciliationAccountSelectAddAccountWrapper>
  )
}
